import { LayoutWithSubNav } from '@components/Layout/Layout';
import { navId } from '@containers/Order/OrderSubNav';

export const OrderLayout = () => LayoutWithSubNav({ navId });
